<template>
  <span
    v-b-tooltip.topleft.v-secondary.noninteractive="{
      title: `${tooltip_text ? tooltip_text : ''}`,
      boundary: 'viewport',
      variant: `${tooltip_variant}`,
    }"
  >
    <b-button
      size="sm"
      :variant="variant"
      :title="text_button"
      @click="handleClick"
      class="noprint"
      :class="custom_class"
      :disabled="disabled_button || loading"
      v-b-tooltip="{ title: null }"
    >
      <b-spinner v-if="loading" small class="mr-1"></b-spinner>
      <b-icon-plus v-if="icon == 'plus'" scale="1.5"></b-icon-plus>
      <b-icon-pencil-square v-else-if="icon == 'square'"></b-icon-pencil-square>
      <b-icon-plus-circle-fill
        v-else-if="icon == 'plus-circle'"
      ></b-icon-plus-circle-fill>
      <b-icon-dash-circle-fill
        v-else-if="icon == 'dash-circle'"
      ></b-icon-dash-circle-fill>
      <b-icon-arrow-left-circle-fill
        v-else-if="icon == 'arrow-left'"
      ></b-icon-arrow-left-circle-fill>
      <b-icon-trash v-else-if="icon == 'trash'"></b-icon-trash>
      <b-icon-lock-fill v-else-if="icon == 'lock'"></b-icon-lock-fill>
      <b-icon-unlock-fill v-else-if="icon == 'unlock'"></b-icon-unlock-fill>
      <b-icon-printer v-else-if="icon == 'printer'"></b-icon-printer>
      <b-icon-files v-else-if="icon == 'files'"></b-icon-files>
      <b-icon-eraser v-else-if="icon == 'clean'"></b-icon-eraser>
      <b-icon-file-excel-fill
        v-else-if="icon == 'file-x'"
      ></b-icon-file-excel-fill>
      <b-icon-file-check-fill
        v-else-if="icon == 'file-check'"
      ></b-icon-file-check-fill>
      <b-icon-card-list v-else-if="icon == 'card'"></b-icon-card-list>
      <b-icon-exclamation-triangle
        v-else-if="icon == 'exclamation'"
      ></b-icon-exclamation-triangle>
      <b-icon-info-circle-fill
        v-else-if="icon == 'info'"
      ></b-icon-info-circle-fill>
      <b-icon-arrows-collapse
        v-else-if="icon == 'arrows-collapse'"
      ></b-icon-arrows-collapse>
      <b-icon-arrows-expand
        v-else-if="icon == 'arrows-expand'"
      ></b-icon-arrows-expand>
      <b-icon-x-circle-fill
        v-else-if="icon == 'x-circle'"
      ></b-icon-x-circle-fill>
      <b-icon-eye v-else-if="icon == 'eye'"></b-icon-eye>
      <b-icon-arrow-counterclockwise
        v-else-if="icon == 'arrow-counterclockwise'"
      ></b-icon-arrow-counterclockwise>
      <slot name="icon"></slot>
      <span v-if="text_button" class="">
        {{ text_button }}
      </span>
    </b-button>
  </span>
</template>

<script>
export default {
  name: "ButtonMedium",
  props: {
    text_button: {
      type: String,
      required: false,
    },
    tooltip_text: {
      type: String,
      required: true,
    },
    click_button: {
      type: Function,
      required: false,
    },
    size: {
      type: String,
      default: "sm",
    },
    variant: {
      type: String,
      default: "none",
    },
    icon: {
      type: String,
      default: "",
      validator: (value) =>
        [
          "plus",
          "plus-circle",
          "dash-circle",
          "arrow-left",
          "x-circle",
          "square",
          "trash",
          "lock",
          "unlock",
          "printer",
          "files",
          "exclamation",
          "info",
          "arrows-collapse",
          "arrows-expand",
          "card",
          "file-check",
          "file-x",
          "clean",
          "eye",
          "arrow-counterclockwise",
          "",
        ].includes(value),
    },
    tooltip_variant: {
      type: String,
      default: "secondary",
      validator: (value) =>
        [
          "primary",
          "secondary",
          "success",
          "danger",
          "warning",
          "info",
          "light",
          "dark",
        ].includes(value),
    },
    custom_class: {
      type: String,
      default: "",
    },
    disabled_button: {
      type: Boolean,
      default: false,
    },
    // Muestra un spinner y deshabilita el botón mientras hay una acción en curso
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    handleClick() {
      // Si se proporciona una función de click, se ejecuta
      if (!this.disabled_button && !this.loading) {
        if (this.click_button) {
          this.click_button();
        } else {
          this.$emit("click");
        }
      }
    },
  },
};
</script>

<style scoped>
</style>